// extracted by mini-css-extract-plugin
export default {"header":"AppHeader_header__zOS+g","logo":"AppHeader_logo__KT7pO"};